
import React from 'react';
import { GraduationCap, MessageCircle, Phone, Mail, Instagram, Facebook, MapPin, BookOpen } from 'lucide-react';
import QRCodeGenerator from '../common/QRCodeGenerator';
import MapComponent from '../common/MapComponent';

const EducationLinktree = () => {
  const socialLinks = [
    { icon: Instagram, url: "https://www.instagram.com/decidedigitaloficial" },
    { icon: Facebook, url: "https://www.facebook.com/decidedigitaloficial" },
  ];

  const mainLinks = [
    {
      icon: BookOpen,
      title: "Cursos Disponíveis",
      subtitle: "Veja nossa grade completa",
      url: "https://decidedigital.com.br/",
      gradient: "from-blue-500 to-indigo-600"
    },
    {
      icon: GraduationCap,
      title: "Matricule-se Online",
      subtitle: "Inscrições abertas",
      url: "https://decidedigital.com.br/",
      gradient: "from-green-500 to-teal-600"
    },
    {
      icon: MessageCircle,
      title: "Suporte Acadêmico",
      subtitle: "Tire suas dúvidas",
      url: "https://wa.me/5569992083972?text=Ol%C3%A1%20gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20os%20cursos",
      gradient: "from-green-600 to-emerald-700"
    },
    {
      icon: Phone,
      title: "Central de Atendimento",
      subtitle: "(69) 99208-3972",
      url: "tel:+5569992083972",
      gradient: "from-purple-500 to-violet-600"
    },
    {
      icon: Mail,
      title: "Secretaria Acadêmica",
      subtitle: "contato@decidedigital.com.br",
      url: "mailto:contato@decidedigital.com.br",
      gradient: "from-pink-500 to-rose-600"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-indigo-800 to-purple-900 py-8 px-4">
      <div className="max-w-md mx-auto">
        <div className="text-center mb-8 animate-fade-in">
          <div className="w-28 h-28 mx-auto mb-4 bg-gradient-to-br from-blue-400 to-purple-600 rounded-full flex items-center justify-center shadow-2xl">
            <GraduationCap className="w-12 h-12 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">EduTech Academy</h1>
          <p className="text-blue-200 leading-relaxed px-4 text-sm">
            📚 Centro de Ensino Digital - Cursos profissionalizantes e técnicos. 
            Prepare-se para o futuro com nossa metodologia inovadora!
          </p>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 mb-6 text-center animate-scale-in">
          <p className="text-white text-sm mb-3">📖 Catálogo de Cursos - Escaneie:</p>
          <div className="flex justify-center">
            <QRCodeGenerator url="https://decidedigital.com.br/" size={110} />
          </div>
        </div>

        <div className="flex justify-center space-x-4 mb-8">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`w-14 h-14 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center hover:bg-white/30 link-button animate-scale-in animate-delay-${index * 100}`}
            >
              <social.icon className="w-6 h-6 text-white" />
            </a>
          ))}
        </div>

        <div className="space-y-4">
          {mainLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`block w-full p-5 bg-gradient-to-r ${link.gradient} rounded-2xl text-white shadow-xl hover:shadow-2xl link-button animate-fade-in animate-delay-${index * 100}`}
            >
              <div className="flex items-center">
                <div className="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mr-4">
                  <link.icon className="w-7 h-7" />
                </div>
                <div className="flex-1">
                  <div className="font-bold text-lg">{link.title}</div>
                  <div className="text-sm opacity-90">{link.subtitle}</div>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 mt-6 animate-fade-in">
          <p className="text-white text-sm mb-3 text-center font-medium">🏫 Nosso Campus:</p>
          <MapComponent 
            latitude={-8.7619} 
            longitude={-63.9019} 
            zoom={16}
            category="education"
            popupText="EduTech Academy - Campus Principal"
          />
        </div>

        <div className="bg-gradient-to-r from-yellow-400 to-orange-500 rounded-2xl p-4 mt-4 text-white text-center animate-fade-in">
          <p className="font-bold text-sm">🏆 +5000 Alunos Formados</p>
          <p className="text-xs opacity-90">Certificação reconhecida pelo MEC</p>
        </div>
      </div>
    </div>
  );
};

export default EducationLinktree;
